import dayjs from 'dayjs';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '考核时间',
          slot: 'accountDate',
          align: 'center',
          minWidth: 120
        },
        {
          title: '业务员',
          slot: 'userName',
          align: 'center',
          minWidth: 200
        },
        {
          title: '所属组织',
          slot: 'organizationName',
          align: 'center',
          minWidth: 200
        },
        // {
        //   title: '入职日期',
        //   key: 'entryTime',
        //   align: 'center',
        //   minWidth: 100,
        //   render(h, params) {
        //       return <span>{dayjs(params.row.entryTime).format('YYYY-MM-DD')}</span>;
        //   }
        // },
        {
          title: '入职天数',
          key: 'entryDays',
          align: 'center',
          minWidth: 100
        }
      ];
      if (this.checkType == 2) {
        let list = [
          {
            title: '职级',
            key: 'rankName',
            align: 'center',
            minWidth: 80
          }
        ];
        columns = [...columns, ...list];
        this.columns = columns;
      } else {
        this.$http({
          url: '/buz/userPromotionRecord/listCommission',
          type: 'GET',
          data: {
            rankId: this.searchParams.rankId,
            type: '2'
          }
        }).then(res => {
          if (res.data) {
            let list2 = res.data.map(i => {
              i.list = i.list.map(item => {
                if (item.ruleName) {
                  return {
                    renderHeader: (h, params) => {
                      return (
                        <div>
                          <span>{item.name}</span>
                          <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip" transfer={true} offset={-13}>
                            <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                            <div slot="content">
                              <p>{item.ruleName}</p>
                            </div>
                          </Poptip>
                        </div>
                      );
                    },
                    key: item.code,
                    align: 'center',
                    minWidth: 150,
                    render(h, params) {
                      if (params.row.detailVos.length) {
                        let data = params.row.detailVos.find(i => i.commissionCode == item.code);
                        return <span>{(data && data.result) || '--'}</span>;
                      } else {
                        return <span>--</span>;
                      }
                    }
                  };
                } else {
                  return {
                    title: item.name,
                    key: item.code,
                    align: 'center',
                    minWidth: 100,
                    render(h, params) {
                      if (params.row.detailVos.length) {
                        let data = params.row.detailVos.find(i => i.commissionCode == item.code);
                        return <span>{(data && data.result) || '--'}</span>;
                      } else {
                        return <span>--</span>;
                      }
                    }
                  };
                }
              });
              i.list.push({
                title: '考核范围',
                key: 'queryRange',
                align: 'center',
                minWidth: 160,
                render(h, params) {
                  if (params.row.detailVos.length) {
                    let data = params.row.detailVos.find(detail => detail.caseName == i.caseName && detail.queryRange);
                    return <span>{(data && data.queryRange) || '--'}</span>;
                  } else {
                    return <span>--</span>;
                  }
                }
              });
              return {
                title: i.caseName,
                align: 'center',
                children: i.list
              };
            });
            let list3 = [
              {
                title: '考核结论',
                key: 'isSuccess',
                align: 'center',
                minWidth: 100,
                render(h, params) {
                  return <span>{params.row.isSuccess == '0' ? '不通过' : '通过'}</span>;
                }
              },
              {
                title: '操作',
                slot: 'action',
                align: 'center',
                minWidth: 100,
                fixed:'right'
              }
            ];
            columns = [...columns, ...list2, ...list3];
          }
          this.columns = columns;
        });
      }
    }
  }
};
